import { getMessages } from '../../../../../../../../store/constants';

export const MESSAGE_DESCRIPTION = getMessages().getText('showOnGantt.description');
export const MESSAGE_MORE_INSTRUCTIONS = getMessages().getText('board_settings.showOnGantt.more_instructions');
export const INSTRUCTIONS_URL = getMessages().getText('board_settings.showOnGantt.instructions.url');
